<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">{{ $t("cli_billing") }}</h4>
                 
                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                     <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                </div>

                <div class="card-body" style="text-align:center;">
                 <b><h3> {{ $t("total_amount") }}   : {{toCurrency(this.sumtotalamountheader)}}</h3></b> 
                </div>


                <div class="card-body">
          
                  <vue-good-table
                    title="list-billing-cli-billing"
                    ref="list-billing-cli-billing"
                    mode="remote"
                    :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                    }"
                    :rows="rows"
                    :columns="columns"
                   
                  >

                  <div slot="table-actions">
                      {{ $t("no_select_data") }}
                  </div>
                  <div slot="selected-row-actions">
                      <button v-if="permision_role.method_delete" class="btn btn-danger btn-xs" style="margin-right:20px;" @click="deleteBilling"> <i
                          class="mdi mdi-send-outline"></i> {{ $t("DeleteTxt") }}
                        </button>

                      <button class="btn btn-success btn-xs" @click="removeBillingIds"><i class="mdi mdi-close"></i> {{
                          $t("unselect_data_txt")
                      }} </button>
                  </div>

                    <template slot="column-filter" slot-scope="{ column }">
                      <span v-if="column.filterOptions.customFilter">

                        <span v-if="column.field =='transactionFromDate'">

                          <date-range-picker style="width:100%" @update="fromDatesChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="fromDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                            <div slot="header" slot-scope="header" class="slot">
                              <a @click="clearfromDatesChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                              <br>
                            </div>
                          </date-range-picker>

                        </span>
                      
                      </span>
                      

                    </template>

                     <template slot="table-row" slot-scope="props">
                      
                      <span v-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              v-if="permision_role.method_read"
                              title="Detail"
                              @click.prevent="
                                detailData(props.index, props.row)
                              "
                            >
                              <i class="mdi mdi-eye" style="font-size:16px"></i>
                              
                            </a>
                            <a
                              href="#"
                              v-if="permision_role.method_update && props.row.status == 'DRAFT' || permision_role.method_update && props.row.status == 'RECALCULATE'"
                              title="Edit"
                              @click.prevent="editData(props.index, props.row)"
                            >
                              <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
                              
                            </a>

                            <a
                              href="#"
                              v-if="permision_role.method_delete && props.row.status == 'DRAFT'"
                              title="Delete"
                              @click.prevent="
                                deleteData(props.index, props.row)
                              "
                            >
                              <i class="mdi mdi-trash-can-outline" style="font-size:16px"></i> 
                            </a>
                      </span>
                      <span v-else-if="props.column.field == 'transactionFromDate'">
                        {{props.row.transactionFromDate}} - {{props.row.transactionToDate}}
                      </span>
                      <span v-else-if="props.column.field == 'amount'">
                        {{toCurrency(props.row.amount)}}
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
  name: "CliBillingIndex",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {    
    return {
      opens:"center",
      locale:{
        format:"yyyy-mm-dd",
      
      },
      fromDates: {
        startDate: null,
        endDate: null
      },
      firstDates:{
        startDate: null,
        endDate: null
      },
      highlighted:{

          dates: [ // Highlight an array of dates
            new Date(),
          ],

      },
      idBillingHeaders:[],
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role:[],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      sumtotalamountheader: 0,
      transactionFromDate:"",
      transactionToDate:"",
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: this.$t("idBillingHeader")+" CLI",
          field: "idBillingHeader",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("idBillingHeader"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("warehouseId_txt"),
          field: "warehouseId",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("warehouseId_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("customerId"),
          field: "customerId",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("customerId_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("customerGroup"),
          field: "customerGroup",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("customerGroup_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("customerSAPCode"),
          field: "customerSAPCode",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("customerSAPCode_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

          {
            label: this.$t("transactionDate_txt"),
            field: "transactionFromDate",
            filterOptions: {
              customFilter: true,
              slotFilterField: 'transactionFromDate',
            },
          },

          {
            label: this.$t("statusTxt"),
            field: "status",
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: this.$t("status_filter_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: ['DRAFT','PROCESSING','COMPLETED','RECALCULATE','CONFIRMED'], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },

          {
            label: this.$t("amount_txt"),
            field: "amount",
            filterOptions: {
              customFilter: false,
              enabled: false, // enable filter for this column
              placeholder: this.$t("amount_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },


          {
            label: this.$t("action_txt"),
            field: "actions",
            sortable: false,
            filterOptions: {
              customFilter: false,
              enabled: false, 
            },
          },
      ],
      rows: [],
    };
  },
  watch: {},
  methods: {

    selectionChanged(ev) {
      let rowsSelection = [];
      this.idBillingHeaders   = [];
      rowsSelection = ev.selectedRows;

      rowsSelection.forEach((item) => {
        if(item.status == "DRAFT"){
          item.vgtSelected = true
          this.idBillingHeaders.push(item.idBillingHeader);
        }else{
          item.vgtSelected = false
        }

      });
      console.log(this.idBillingHeaders)
    },

    removeBillingIds(){
      this.idBillingHeaders = [];
      this.$refs['list-billing-cli-billing'].unselectAllInternal()
    },


    deleteBilling(){
      this.isLoading = true;
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          let data = {
            idBillingHeaders: this.idBillingHeaders
          }
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/delete-mass";
          this.$http
            .post(baseURI, data)
            .then((response) => {
                this.loading();
                this.idBillingHeaders = [];
                this.success(response.data.datas.messages);
                this.loadItems();
            })
            .catch((error) => {
              this.loading();
       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }else{

          this.isLoading = false;

        }
      });


    },
    toCurrency (value) {
      if (typeof value !== "number") {
          return value;
      }
      var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'IDR'
      });
      return formatter.format(value);
    },

    fromDatesChange(){

      if(this.fromDates.startDate && this.fromDates.endDate){
        this.transactionFromDate=this.$moment(String(this.fromDates.startDate)).format('YYYY-MM-DD');
        this.transactionToDate=this.$moment(String(this.fromDates.endDate)).format('YYYY-MM-DD');
        this.loadItems()
      }

    },


    clearfromDatesChange(){
      this.fromDates={
        startDate: null,
        endDate: null
      };
      this.transactionFromDate = ""
      this.transactionToDate = ""
      this.loadItems()
    },

    downloadData() {
      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      let transactionFromDate = this.transactionFromDate
      let transactionToDate   = this.transactionToDate


      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouseId=${this.serverParams.columnFilters.warehouseId}&customerId=${this.serverParams.columnFilters.customerId}&customerSAPCode=${this.serverParams.columnFilters.customerSAPCode}&customerGroup=${this.serverParams.columnFilters.customerGroup}&transactionFromDate=${transactionFromDate}&transactionToDate=${transactionToDate}&status=${this.serverParams.columnFilters.status}&idBillingHeader=${this.serverParams.columnFilters.idBillingHeader}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
   

    editData(index, row) {
      var params = this.$onRandom(row.idBillingHeader);
      window.location.href = "/billing-cli-billing/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.idBillingHeader);
      window.location.href = "/billing-cli-billing/detail/" + params;
    },

    deleteData(index, row, status) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/delete/" + row.idBillingHeader;
          this.$http
            .delete(baseURI, formData,{ timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }else{

          this.isLoading = false;
          
        }
      });
    },

    // load items is what brings back the rows from server
    loadItems() {
      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing";
      this.isLoading = true;
      
      let transactionFromDate = this.transactionFromDate
      let transactionToDate   = this.transactionToDate


      return this.$http
        .get(
           baseURI +
           `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouseId=${this.serverParams.columnFilters.warehouseId}&customerId=${this.serverParams.columnFilters.customerId}&customerSAPCode=${this.serverParams.columnFilters.customerSAPCode}&customerGroup=${this.serverParams.columnFilters.customerGroup}&transactionFromDate=${transactionFromDate}&transactionToDate=${transactionToDate}&status=${this.serverParams.columnFilters.status}&idBillingHeader=${this.serverParams.columnFilters.idBillingHeader}`,
          { timeout: 10000 })
        .then((response) => {
          this.isLoading = false;
          this.rows = [];
          let datas = response.data.datas.data
          datas.forEach((value) => {
              if(value.status != "DRAFT"){
                value.vgtDisabled = true
                value.vgtSelected = false
              }
              this.rows.push(value);

          });
          // this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.sumtotalamountheader = response.data.sumtotalamountheader;
        }).catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'BillingCliController'){
          rolePermision = permision;
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

   
      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped>
.daterangepicker.single.show-ranges.show-weeknumbers{
    min-width: 386px;
}
</style>